// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CardMetricVariation {
  display: flex;
  flex-direction: column;
}
.CardMetricVariation .variation-centered .metric-variation.metric-variation-positive {
  color: var(--success);
}
.CardMetricVariation .variation-centered .metric-variation.metric-variation-negative {
  color: var(--danger);
}
.CardMetricVariation .CardMetricVariation-metrics {
  color: var(--gray);
}`, "",{"version":3,"sources":["webpack://./src/components/CardMetricVariation/index.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;AACF;AAGM;EACE,qBAAA;AADR;AAGM;EACE,oBAAA;AADR;AAME;EACE,kBAAA;AAJJ","sourcesContent":[".CardMetricVariation {\n  display: flex;\n  flex-direction: column;\n\n  .variation-centered {\n    .metric-variation {\n      &.metric-variation-positive {\n        color: var(--success);\n      }\n      &.metric-variation-negative {\n        color: var(--danger);\n      }\n    }\n  }\n\n  .CardMetricVariation-metrics {\n    color: var(--gray);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
